export default __webpack_public_path__ + "static/media/new_people_logo.2c97c16d.png";